import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import {
	INavbarNoticeState,
	setNavbarNotices,
	showNavbarProgress,
} from '../actions/navbar';

/**
 * ナビゲーションバーのState型
 */
interface INavbarShowState {
	isShowProgress?: boolean;
}
export type INavbarState = INavbarNoticeState & INavbarShowState;

/**
 * ナビゲーションバーのState初期値
 */
const initialState: INavbarState = {
	applyingCancelApplyCurriculumCnt: 0,
	applyingCancelApplyTrainingCnt: 0,
	applyingPerformanceApplyTrainingCnt: 0,
	applyingStudentApplyCurriculumCnt: 0,
	applyingStudentApplyTrainingCnt: 0,
	isShowProgress: false,
	waitingPerformanceApprovalCnt: 0,
	waitingStudentApprovalCnt: 0,
	waitingStudentCancelCnt: 0,
};

/**
 * ナビゲーションバー用reducer
 * @param state State
 * @param action アクション
 */
const navbar = (state = initialState, action: Action) => {
	if (isType(action, setNavbarNotices)) {
		return {
			...state,
			...action.payload.noticeState,
			setNoticeAt: new Date(),
		};
	}

	if (isType(action, showNavbarProgress)) {
		return {
			...state,
			isShowProgress: action.payload.isShow,
		};
	}

	return state;
};

export default navbar;



// WEBPACK FOOTER //
// ./src/reducers/navbar.ts